import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleDiscoverMissions = () => {
    navigate('/missions');
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          alt="Équipe sportive en action"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <Container maxWidth="lg" className="hero-container">
        <Box className="hero-content">
          <Typography variant="h1" className="hero-title">
            Mission Sport
          </Typography>
          <Typography variant="h2" className="hero-subtitle">
            Connecter les talents, créer les opportunités
          </Typography>
          <Typography variant="body1" className="hero-description">
            La plateforme de référence qui unit les organisations sportives 
            et les professionnels indépendants pour donner vie à vos projets sportifs.
          </Typography>
          <Button 
            variant="contained" 
            size="large" 
            className="hero-cta"
            onClick={handleDiscoverMissions}
            endIcon={<FaArrowRight />}
          >
            Découvrir les missions
          </Button>
        </Box>
      </Container>
    </section>
  );
};

export default HeroSection;